var _path, _path2, _path3, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWave(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 547,
    height: 199,
    viewBox: "0 0 547 199",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_653_8834",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -92,
    y: -3,
    width: 706,
    height: 239
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.62939e-06 199H539.896C528.056 166.911 209.723 16.1687 71.631 -0.994994C-66.4614 -18.1587 -86.2334 116.19 -91.5613 199L7.62939e-06 199Z",
    fill: "url(#paint0_linear_653_8834)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M550.999 88.0576V199H0V107.958C0 107.958 87.3681 145.161 130.752 133.828C174.136 122.494 286.742 -17.6612 385.859 22.1388C484.976 61.9388 487.222 93.8878 550.999 88.0576Z",
    fill: "url(#paint1_linear_653_8834)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3148 198.994L-20.6438 190.803C-88.6066 293.225 -38.4816 187.875 -75.4374 176.306L-77.1718 175.847C-76.5733 175.978 -75.9955 176.131 -75.4374 176.306L-20.6438 190.803C-5.82458 168.47 14.6091 136.259 42.7843 91.0425C202.126 -164.673 24.8215 209.447 512.822 66.0879C622.857 33.7634 654.478 46.9237 549.39 198.994L496.153 198.994H10.3148Z",
    fill: "url(#paint2_linear_653_8834)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_653_8834)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 547,
    height: 199,
    fill: "#2709BB",
    fillOpacity: 0.48
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_653_8834",
    x1: 172.337,
    y1: -298.003,
    x2: 151.514,
    y2: 185.127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_653_8834",
    x1: 94.5651,
    y1: -291.535,
    x2: 221.508,
    y2: 178.202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_653_8834",
    x1: 340.601,
    y1: -431.437,
    x2: 211.744,
    y2: 171.457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave);
export default __webpack_public_path__ + "static/media/wave.8948bf8acb78781cd4ab85d23fb6aa4f.svg";
export { ForwardRef as ReactComponent };